var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilePptx(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "i6uorswr6a",
    d: "M.164.125h7.565v7.693H.164z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 31.705,
    rx: 4,
    transform: "translate(.063 .148)",
    fill: "#CC492E"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.154 8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1z57ur6psb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i6uorswr6a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.818h7.565C7.225 3.708 4.018.442 0 .125v7.693z",
    fill: "#FFF",
    mask: "url(#1z57ur6psb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.692 17.154a7.846 7.846 0 1 1-7.846-7.846v7.846h7.846z",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePptx);
export default __webpack_public_path__ + "static/media/file-pptx.8b81b1d2.svg";
export { ForwardRef as ReactComponent };